"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _draftJsCustomStyles = _interopRequireDefault(require("draft-js-custom-styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _createStyles = (0, _draftJsCustomStyles["default"])(['addFontFamily'], 'CUSTOM_', {}),
    styles = _createStyles.styles;

var FontsPicker = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FontsPicker, _Component);

  function FontsPicker() {
    var _this;

    _this = _Component.call(this) || this;

    _defineProperty(_assertThisInitialized(_this), "onWindowClick", function () {
      // Call `onOverrideContent` again with `undefined`
      // so the toolbar can show its regular content again.
      _this.props.onOverrideContent(undefined);
    });

    _this._changeFont = _this._changeFont.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FontsPicker.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      window.addEventListener('click', _this2.onWindowClick);
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
  };

  _proto._onClick = function _onClick(e) {
    e.preventDefault();
    e.stopPropagation();
  };

  _proto._changeFont = function _changeFont(e) {
    var _this3 = this;

    e.preventDefault();
    var editorState = this.props.getEditorState();
    var newEditorState = styles.addFontFamily.add(editorState, e.target.value);
    this.props.onOverrideContent(undefined);
    setTimeout(function () {
      _this3.props.setEditorState(newEditorState);
    });
  };

  _proto.render = function render() {
    var currentStyle = styles.addFontFamily.current(this.props.getEditorState()) || "ROBOTO";
    var selectedTheme = this.props.selectedTheme;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "toolbarButtonWrapper"
    }, /*#__PURE__*/_react["default"].createElement("select", {
      className: "toolbarButton",
      onClick: this._onClick,
      onChange: this._changeFont,
      value: currentStyle
    }, /*#__PURE__*/_react["default"].createElement("option", {
      value: "ONE",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_ONE"]
    }, "Arial"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "TWO",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_TWO"]
    }, "Arial Black"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "THR",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_THR"]
    }, "Comic Sans MS"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "FUR",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_FUR"]
    }, "Courier New"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "FIV",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_FIV"]
    }, "Helvetica"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "SIX",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_SIX"]
    }, "Impact"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "SVN",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_SVN"]
    }, "Lucida Console"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "EGT",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_EGT"]
    }, "Lucida Sans Unicode"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "NNE",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_NNE"]
    }, "Lucida Grande"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "TEN",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_TEN"]
    }, "Palatino Linotype"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "ELE",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_ELE"]
    }, "Sans Serif"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "TWE",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_TWE"]
    }, "Tahoma"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "THT",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_THT"]
    }, "Trebuchet MS"), /*#__PURE__*/_react["default"].createElement("option", {
      value: "FTN",
      style: selectedTheme["CUSTOM_ADD_FONT_FAMILY_FTN"]
    }, "Verdana")));
  };

  return FontsPicker;
}(_react.Component);

var _default = FontsPicker;
exports["default"] = _default;
module.exports = exports.default;